import React, { Component } from "react";

import FloatingContainerService from "../../services/FloatingContainerService";
import FloatingNotes from "./FloatingNotes";

class FloatingNotesContainer extends Component {
	constructor(props) {
		super(props);

		this.currentRef = null;
	}

	update = o => {
		return new Promise(resolve => {
			this.setState(o, resolve);
		});
	};

	componentDidMount() {
		FloatingContainerService.storeReference({
			name: "notes",
			ref: this.currentRef,
			width: 465,
			height: 560
		});
	}

	render() {
		return <FloatingNotes ref={ref => (this.currentRef = ref)} />;
	}
}

export default FloatingNotesContainer;
